import withHelmet from '../HOC/withHelmet';
import Faq from '../components/faq/Faq';

export default withHelmet(Faq, 'Frequently asked questions');
